import { render, staticRenderFns } from "./ScreenImagePreview.vue?vue&type=template&id=68ff9993&scoped=true"
import script from "./ScreenImagePreview.vue?vue&type=script&lang=js"
export * from "./ScreenImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenImagePreview.vue?vue&type=style&index=0&id=68ff9993&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff9993",
  null
  
)

export default component.exports